export enum IncompleteSchainHandling {
  DropRequest = 'DROP_REQUEST',
  Incomplete = 'INCOMPLETE',
  Complete = 'COMPLETE',
}
